import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { Transaction } from '@repo/common-types';
import { getBlockExplorerUrl } from '@/common/utils/block-explorer';
import { getStatusBadgeColor } from '@/pages/deposits/utils/get-status-badge-color';
import { trimHash } from '@/common/utils/trim-hash';

interface TransactionDetailsProps {
  transaction: Transaction;
  title: string;
  chain: string;
  isOutbound?: boolean;
}

const TransactionDetails: React.FC<TransactionDetailsProps> = ({ transaction, title, chain, isOutbound = false }) => {
  if (!transaction) return null;

  return (
    <Card className="mb-3">
      <CardBody>
        <CardTitle tag="h5">{title}</CardTitle>
        <div className="table-responsive">
          <table className="table-bordered mb-0 table">
            <tbody>
              <tr>
                <th scope="row">Transaction ID</th>
                <td>
                  <a
                    href={getBlockExplorerUrl(isOutbound ? 'polygon' : chain, transaction.txId)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-underline"
                    title={transaction.txId || ''}
                  >
                    {trimHash(transaction.txId || '')}
                  </a>
                </td>
              </tr>
              <tr>
                <th scope="row">Status</th>
                <td>
                  <span className={`badge mb-0 p-0 text-start ${getStatusBadgeColor(transaction.status)}`}>
                    {transaction.status}
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row">Created At</th>
                <td>{new Date(transaction.createdAt).toLocaleString()}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </CardBody>
    </Card>
  );
};

export default TransactionDetails;
